module.exports = __webpack_public_path__ + "img/c06_unittechlargegarden_Normal_ua.cca7a5a1.webp";